import React, { useEffect } from "react";
import { X } from "lucide-react";

export default function ImageLightbox({ src, alt, label, meta, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  if (!src) return null;

  return (
    <div
      data-testid="image-lightbox-overlay"
      onClick={onClose}
      className="keep-dark fixed inset-0 z-[100] bg-black/95 backdrop-blur-sm flex items-center justify-center p-4 sm:p-10 animate-fade-up"
      style={{ animationDuration: "150ms" }}
    >
      {label && (
        <span data-testid="image-lightbox-label" className="absolute top-5 left-6 text-[10px] uppercase tracking-widest text-zinc-400 bg-black/60 border border-white/10 rounded-full px-3 py-1.5">
          {label}
        </span>
      )}
      <button
        data-testid="image-lightbox-close"
        onClick={onClose}
        className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/5 border border-white/15 flex items-center justify-center text-zinc-300 hover:bg-white/15 hover:text-white transition-colors"
        aria-label="Close"
      >
        <X className="w-5 h-5" />
      </button>
      <img
        data-testid="image-lightbox-image"
        src={src}
        alt={alt || "Card image"}
        onClick={(e) => e.stopPropagation()}
        className="max-w-full max-h-[92vh] object-contain rounded-xl border border-white/10 shadow-2xl"
      />
      {meta && (
        <span
          data-testid="image-lightbox-meta"
          className="absolute bottom-6 left-1/2 -translate-x-1/2 text-xs font-semibold text-white bg-black/75 border border-white/15 rounded-full px-4 py-2 whitespace-nowrap"
        >
          {meta}
        </span>
      )}
    </div>
  );
}
